module.exports = __webpack_public_path__ + "img/lookbook_6_center_back.2d991b0f.png";